var Dispatcher = require('flux').Dispatcher;
var BasePricesDashboardDispatcher = new Dispatcher();
export default BasePricesDashboardDispatcher